var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_4",
    "data-name": "Logo 4",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 406.75 147.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#4cc2f1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.4,289.46a11.37,11.37,0,0,1-11.89,9.69,9,9,0,0,1-4.72-1.33,8.46,8.46,0,0,1-3.15-3.66,13.84,13.84,0,0,1-1.24-5.3,17.85,17.85,0,0,1,.14-3.2l.34-2.41a18.17,18.17,0,0,1,4.62-10.36,11.67,11.67,0,0,1,8.94-3.69,8.72,8.72,0,0,1,6.5,2.65,10.56,10.56,0,0,1,2.54,7.14h-3.74c-.17-4.08-1.77-6.29-4.8-6.61l-.66,0a7.74,7.74,0,0,0-6.32,2.82,15.16,15.16,0,0,0-3.27,7.95l-.44,3-.12,1.76a9.83,9.83,0,0,0,1.31,5.85,5,5,0,0,0,4.25,2.26,7.55,7.55,0,0,0,5-1.46,9.8,9.8,0,0,0,3-5Z",
    transform: "translate(-59.52 -152)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.28,291.12H310.47l-4,7.63h-4L318.3,269.6h3.3l5.77,29.15h-3.7ZM312.13,288h9.59l-2.42-13.59Z",
    transform: "translate(-59.52 -152)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.79,291.24q.43-3.19-3.32-4.68L341,285.3l-1.16-.5q-5.85-2.67-5.46-7.49A7.79,7.79,0,0,1,336,273a9.46,9.46,0,0,1,3.87-2.87,12.5,12.5,0,0,1,5.14-.95,10.32,10.32,0,0,1,4.71,1.18,7.57,7.57,0,0,1,3.15,3.14,8.53,8.53,0,0,1,1,4.53l-3.78,0a5.26,5.26,0,0,0-1.2-4.17,5.4,5.4,0,0,0-4-1.52,7.54,7.54,0,0,0-4.59,1.29,5,5,0,0,0-2.12,3.61q-.4,3,3.66,4.53l3,1.06,1.5.65q5.64,2.59,5.22,7.72a7.71,7.71,0,0,1-1.66,4.26,9.32,9.32,0,0,1-3.91,2.77,13.58,13.58,0,0,1-5.32.92,11,11,0,0,1-5-1.17,8.22,8.22,0,0,1-3.46-3.15,8,8,0,0,1-1-4.55l3.77,0a5,5,0,0,0,1.41,4.14,6.37,6.37,0,0,0,4.49,1.57,8.14,8.14,0,0,0,4.79-1.26A4.94,4.94,0,0,0,347.79,291.24Z",
    transform: "translate(-59.52 -152)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.57,285.28H361.32l-1.8,10.33h14.25l-.56,3.14h-18l5.06-29.15h17.8l-.56,3.14h-14l-1.62,9.39h12.26Z",
    transform: "translate(-59.52 -152)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.83,269.6l5.1,23.74,13.38-23.74h4.94l-5.06,29.15h-3.75l2-11.53,2.38-11.73-13.22,23.26h-2.88L385.53,275l-1.81,12.57-1.94,11.15H378l5.06-29.15Z",
    transform: "translate(-59.52 -152)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.31,291.12H418.5l-4,7.63h-4l15.84-29.15h3.3l5.77,29.15h-3.71ZM420.16,288h9.59l-2.42-13.59Z",
    transform: "translate(-59.52 -152)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.2,298.75h-3.64l-10.41-22.62-3.93,22.62h-3.78l5.06-29.15h3.65l10.43,22.72,3.94-22.72h3.75Z",
    transform: "translate(-59.52 -152)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 37,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 74,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 111,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.33,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 127.22,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.33,
    y: 37,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.33,
    y: 74,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.33,
    y: 111,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 165.37,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 165.37,
    y: 37,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 165.37,
    y: 74,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 165.37,
    y: 111,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.67,
    y: 111,
    width: 34,
    height: 34,
    rx: 7.92
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.67,
    width: 34,
    height: 34,
    rx: 7.92
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.21f179eab77dab910a7d57bfbe7e7a6a.svg";
export { ForwardRef as ReactComponent };